import { render } from "./app-form-invoice-additional-details.vue?vue&type=template&id=0efb43d9"
import script from "./app-form-invoice-additional-details.vue?vue&type=script&lang=js"
export * from "./app-form-invoice-additional-details.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-invoice-additional-details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0efb43d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0efb43d9', __exports__)) {
    console.log('reload')
    api.reload('0efb43d9', __exports__)
  }
  
  module.hot.accept("./app-form-invoice-additional-details.vue?vue&type=template&id=0efb43d9", () => {
    console.log('re-render')
    api.rerender('0efb43d9', render)
  })

}


export default __exports__